import { Link } from 'react-router-dom';

// Carte d'un projet personnel. Les données viennent de l'API (table projects) :
// un seul rendu pour tous les projets, l'ajout se fait côté admin Django.
const ProjectCard = ({ project }) => {
    const hasLink = Boolean(project.link_url && project.link_label);

    return (
        <div className="project-card">
            <div className="project-card-header">
                {project.logo && (
                    <img
                        src={project.logo}
                        alt={`Logo ${project.name}`}
                        className="project-logo"
                    />
                )}
                <div className="project-card-titles">
                    <span className="project-name">{project.name}</span>
                    <span className="project-tagline">{project.tagline}</span>
                </div>
            </div>
            <p className="project-description">{project.description}</p>
            {project.stack && project.stack.length > 0 && (
                <div className="project-stack">
                    {project.stack.map((tech, index) => (
                        <span key={index} className="project-tech">{tech}</span>
                    ))}
                </div>
            )}
            {/* Un lien externe doit sortir du routeur React ; un lien interne
                passe par <Link> pour éviter un rechargement complet. */}
            {hasLink && (
                project.link_is_external ? (
                    <a
                        href={project.link_url}
                        className="project-link"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {project.link_label}
                    </a>
                ) : (
                    <Link to={project.link_url} className="project-link">
                        {project.link_label}
                    </Link>
                )
            )}
        </div>
    );
};

export default ProjectCard;
